/*
* @Author: echo
* 定制老师合同签署信息填写页面
*/
<template>
    <div>
        <div class="common-container">
        <v-container fill-height
                    fluid class="pa-0 pt-2">
        <v-layout  row wrap>
            <v-flex>
            <v-flex xs12 pt-4 >
                <v-layout row>
                    <v-flex xs12>
                        <h2 class="mb-0 blue-title contract-title">Sign Contract &#8195;
                            <i class="status" :style="{'color':stateColor,'text-decoration': (isPreview==1||isPreview==2)?'underline':''}"  @click="processInfo"> {{contractState}}</i>
                            <div class="arrow_box" v-if="download">
                                <div class="py-2" style="border-bottom:1px solid #fff"><i class="material-icons">file_download</i><span @click="downloadContract(1)">《INDEPENDENT CONTRACTOR AGREEMENT》</span></div>
                                <!-- <div class="py-2"><i class="material-icons">file_download</i><span @click="downloadContract(2)">《PRE-TESOL CERTIFICATION BOND AGREEMENT》</span></div> -->
                            </div>
                        </h2>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-form ref="form">
                    <v-card class="common-card mt-4">
                        <h4 class="headline mb-0 head-title">Contract Information Supplement</h4>
                        <v-flex row>
                            <v-flex xs12 class="mt-2">
                                <v-card flat height="100%">
                                            <v-layout row>
                                                <v-flex xs6 class="pr-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Paypal/Bank Name</v-subheader>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            single-line
                                                            outline
                                                            box
                                                            class="body-2"
                                                            v-model.trim="form.BankName"
                                                            :error-messages="$v.form.BankName.$error ? 'Required': ''"
                                                            @input="$v.form.BankName.$touch()"
                                                            :disabled="!isFirst"
                                                            ></v-text-field>
                                                    </v-flex>
                                                </v-flex>
                                                <v-flex xs6 class="pl-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Account Number&#8195;
                                                            <v-tooltip bottom content-class="common-tooltip">
                                                                <template v-slot:activator="{ on }">
                                                                    <i v-on="on" class="material-icons pink-text cursor-pointer">info</i>
                                                                </template>
                                                                <span>
                                                                    For PayPal : Input  your PayPal account here.<br/>
                                                                    For Bank Transfer (e.g. Airwallex or other platforms) : Input your bank account number.
                                                                </span>
                                                            </v-tooltip>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            single-line
                                                            outline
                                                            box
                                                            class="body-2"
                                                            v-model.trim="form.AccountNumber"
                                                            :error-messages="$v.form.AccountNumber.$error ? 'Required': ''"
                                                            @input="$v.form.AccountNumber.$touch()"
                                                            :disabled="!isFirst"
                                                            ></v-text-field>
                                                    </v-flex>
                                                </v-flex>  
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6 class="pr-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Branch&#8195;
                                                            <v-tooltip bottom content-class="common-tooltip">
                                                                <template v-slot:activator="{ on }">
                                                                    <i v-on="on" class="material-icons pink-text cursor-pointer">info</i>
                                                                </template>
                                                                <span>
                                                                    For Paypal : Fill in "Paypal" directly here.<br/>
                                                                    For Bank Transfers : Input branch name. 
                                                                </span>
                                                            </v-tooltip>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            single-line
                                                            outline
                                                            box
                                                            class="body-2"
                                                            v-model.trim="form.Branch"
                                                            :error-messages="$v.form.Branch.$error ? 'Required': ''"
                                                            @input="$v.form.Branch.$touch()"
                                                            :disabled="!isFirst"
                                                            ></v-text-field>
                                                    </v-flex>
                                                </v-flex>
                                                <v-flex xs6 class="pl-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Account Name</v-subheader>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            single-line
                                                            outline
                                                            box
                                                            class="body-2"
                                                            v-model.trim="form.AccountName"
                                                            :error-messages="$v.form.AccountName.$error ? 'Required': ''"
                                                            @input="$v.form.AccountName.$touch()"
                                                            :disabled="!isFirst"
                                                            ></v-text-field>
                                                    </v-flex>
                                                </v-flex>     
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6 class="pr-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Paypal/Bank statement photo&#8195;
                                                            <v-tooltip bottom content-class="common-tooltip">
                                                            <template v-slot:activator="{ on }">
                                                                <i v-on="on" class="material-icons pink-text cursor-pointer">info</i>
                                                            </template>
                                                            <span>Your Paypal/Bank Statement Photo (for the Service Fee Release). The photo should be clear enough for us to check your info. The details you fill in must be the same as that on your bank statement photo. The account holder must be the contract signatory.</span>
                                                        </v-tooltip>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-layout row>
                                                        <v-flex xs8> 
                                                            <input v-show="0"
                                                                type="file"
                                                                @change="changeBankPhoto"
                                                                ref="inputer"
                                                                multiple
                                                                id="bankPhotoFile"
                                                                accept=".jpg,.png" />
                                                            <v-text-field 
                                                                single-line
                                                                outline
                                                                box
                                                                class="body-2"
                                                                disabled
                                                                v-model="form.BankStatementPhotoName"
                                                                :error-messages="$v.form.BankStatementPhotoName.$error ? 'Required': ''"
                                                                @input="$v.form.BankStatementPhotoName.$touch()"
                                                                ></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs4 pl-3>
                                                            <v-btn class="text-none white--text blue-button upload-btn" @click="replaceBank" :disabled="!isFirst">
                                                                        <v-icon dark left>cloud_upload</v-icon>Click to Upload</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs6 class="pl-5">
                                                    <v-flex xs12>
                                                        <v-subheader>Electronically signed photo&#8195;
                                                            <v-tooltip bottom content-class="common-tooltip">
                                                                <template v-slot:activator="{ on }">
                                                                    <i v-on="on" class="material-icons pink-text cursor-pointer">info</i>
                                                                </template>
                                                                <span>Your e-signature here must be the same as your ID(Full Name) with 'CLEAR' signature.</span>
                                                            </v-tooltip>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-layout row>
                                                        <v-flex xs8> 
                                                            <input v-show="0"
                                                                type="file"
                                                                @change="changeSignedPhoto"
                                                                ref="inputer"
                                                                multiple
                                                                id="signedPhotoFile"
                                                                accept=".jpg,.png" />
                                                            <v-text-field 
                                                                single-line
                                                                outline
                                                                box
                                                                class="body-2"
                                                                disabled
                                                                v-model="form.ElectronicallySignedPhotoName"
                                                                :error-messages="$v.form.ElectronicallySignedPhotoName.$error ? 'Required': ''"
                                                                @input="$v.form.ElectronicallySignedPhotoName.$touch()"
                                                                ></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs4 pl-3>
                                                            <v-btn class="text-none white--text blue-button upload-btn" @click="replaceSigned" :disabled="!isFirst">
                                                                        <v-icon dark left>cloud_upload</v-icon>Click to Upload</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>     
                                            </v-layout>
                                </v-card>
                            </v-flex>
                        </v-flex>
                        <v-flex mt-4 font-weight-black>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-checkbox
                                        v-model="radioAgree"
                                        :disabled="!isFirst"
                                        color="#3e67fb"
                                    ></v-checkbox>
                                    <span class="agreeAudit blue-title">I have read and agree to the terms of the Submit  Audit <a @click="previewContract(1)">《INDEPENDENT CONTRACTOR AGREEMENT》</a>
                                        <!-- <a @click="previewContract(2)">《PRE-TESOL CERTIFICATION BOND AGREEMENT》</a> -->
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center">
                            <v-btn class="text-none red-button submit-contract" :disabled="!isFirst || !radioAgree"  @click="onSubmit">{{submitText}}</v-btn>
                        </v-flex>
                    </v-card>
                </v-form>
            </v-flex>
            </v-flex>
        </v-layout>
        </v-container>
        </div>
        <remark-modal @myevent="closeRemark" :remarkText="remarkText" :isRemark="isRemark"></remark-modal>
        <!-- 号码验证弹窗 -->
        <template>
            <v-dialog
                v-model="dialog"
                :max-width="options.width"
                v-bind:style="{ zIndex: options.zIndex }"
                :persistent="false">
                <v-card>
                    <v-card-title class="title a-3 pt-4 ml-2 verify-card">
                        <div :class="{ 'current-verify': currentVerifyType === 1 }" @click="changeVerifyType(1)">Mobile Phone</div>
                        <div :class="{ 'current-verify': currentVerifyType === 2 }" @click="changeVerifyType(2)">Email Address</div>
                        <div class="header-close" title="close" @click="dialog = false"><v-icon>close</v-icon></div>
                    </v-card-title>

                    <v-card-text class="pa-4">
                        <v-form v-model="phoneValid" ref="phoneForm">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-flex xs12>
                                        <v-subheader class="form-title">Phone Number</v-subheader>
                                    </v-flex>
                                    <v-layout row>
                                        <v-flex xs2 pr-3>
                                            <span class="binding-area">+&nbsp;
                                                <input type="text" name="" id="" class="area-code" v-model="areaCode">
                                            </span>
                                        </v-flex>
                                        <v-flex xs10>
                                            <v-text-field
                                                single-line
                                                outline
                                                box
                                                class="body-2"
                                                v-model.trim="phoneNumber"
                                                :rules="[rules.required]"
                                                required
                                                oninput="value=value.replace(/[^0-9-]+/,'')"
                                                ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex> 
                            </v-layout>
                        </v-form>
                        <v-form v-model="codeValid" ref="codeForm">
                            <v-layout row wrap>
                                <v-flex xs8 pr-3>
                                    <v-flex xs12>
                                        <v-subheader class="form-title">Verification Code</v-subheader>
                                    </v-flex>
                                    <v-flex>
                                        <v-text-field
                                            single-line
                                            outline
                                            box
                                            class="body-2"
                                            v-model.trim="verificationCode"
                                            required
                                            :rules="[rules.required]"
                                            oninput="value=value.replace(/[^0-9-]+/,'')"
                                            ></v-text-field>
                                    </v-flex>
                                </v-flex> 
                                <v-flex xs4>
                                    <v-btn
                                        text
                                        @click="sendCode"
                                        class="text-none white--text blue-button send"
                                        :disabled="!canGet"
                                    >
                                    {{getCodeBtn}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <p style="color: rgba(50, 57, 122, 0.4)">* Please make sure it is your contact information</p>
                    </v-card-text>

                    <div class="binding-footer">
                        <div class="flex-grow-1"></div>
                        <v-btn
                            class="text-none red-button"
                            text
                            @click="bindPhone"
                        >
                            Submit
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialog2"
                :max-width="options.width"
                v-bind:style="{ zIndex: options.zIndex }"
                :persistent="false">
                <v-card>
                    <v-card-title class="title a-3 pt-4 ml-2 verify-card">
                        <div :class="{ 'current-verify': currentVerifyType === 1 }" @click="changeVerifyType(1)">Mobile Phone</div>
                        <div :class="{ 'current-verify': currentVerifyType === 2 }" @click="changeVerifyType(2)">Email Address</div>
                        <div class="header-close" title="close" @click="dialog2 = false"><v-icon>close</v-icon></div>
                    </v-card-title>

                    <v-card-text class="pa-4">
                        <v-form v-model="codeValid" ref="codeForm2">
                            <v-layout row wrap>
                                <v-flex xs8 pr-3>
                                    <v-flex xs12>
                                        <v-subheader class="form-title">Email Verification Code</v-subheader>
                                    </v-flex>
                                    <v-flex>
                                        <v-text-field
                                            single-line
                                            outline
                                            box
                                            class="body-2"
                                            v-model.trim="emailverificationCode"
                                            required
                                            :rules="[rules.required]"
                                            oninput="value=value.replace(/[^0-9-]+/,'')"
                                            ></v-text-field>
                                    </v-flex>
                                </v-flex> 
                                <v-flex xs4>
                                    <v-btn
                                        text
                                        @click="sendEmailCode"
                                        class="text-none white--text blue-button send"
                                        :disabled="!canGet2"
                                    >
                                    {{getCodeBtn2}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <p style="color: rgba(50, 57, 122, 0.4)">{{ emailTip }}</p>
                    </v-card-text>

                    <div class="binding-footer">
                        <div class="flex-grow-1"></div>
                        <v-btn
                            class="text-none red-button"
                            text
                            @click="bindEmail"
                        >
                            Submit
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<script>
import { saveContractInfo, getContractInfo, showContract, sendVerificationCode, getSignPhoneInfo, signContractVerifyCode, sendEmailVerificationCode, signContractEmailVerifyCode } from '@/api/teachinfo'
import vmodel from '@/mixins/v-model'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import remarkModal from '../../components/dialogs/remarkModal'
import store from 'store2'
import { mapGetters } from 'vuex'
import {uploader} from '@/utils/patchUpload'
export default {
    computed: {
      ...mapGetters([
        'user'
      ])
    },
    mixins: [vmodel, validationMixin],
    components:{
        remarkModal
    },
    validations () {
        return{
            form: {
                BankName: { required },
                AccountNumber: { required },
                Branch: { required },
                AccountName: { required },
                BankStatementPhotoName: { required },
                ElectronicallySignedPhotoName: { required }
            },
        }
    },
    data:()=>({
        radioAgree:true,
        isFirst:true,
        contractState:'Not Signed',
        submitText:'Submit Audit',
        stateColor:"#32397a66",
        isPreview:-1,
        downloadFile:"",
        contractTESOLFile:"",
        isRemark:false,
        remarkText:"",
        constractView:true,
        authCode:"",
        form:{
            BankName:'',
            AccountNumber:'',
            Branch:'',
            AccountName:'',
            BankStatementPhoto:'',
            BankStatementPhotoFile:'',
            BankStatementPhotoName:'',
            ElectronicallySignedPhoto:'',
            ElectronicallySignedPhotoFile:'',
            ElectronicallySignedPhotoName:''
        },

        dialog:false,
        phoneNumber:'',
        verificationCode:'',
        canGet: true,
        timer: null,
        count: 60,
        getCodeBtn:"Send",
        options:{
            width: 550,
            zIndex: 200
        },
        areaCode:'63',
        offCountdown:0,
        preview:false,
        download:false,
        phoneValid: false,
        codeValid: false,
        rules: {
            required: value => !!value || 'Required.'
        },

        currentVerifyType: 1,
        dialog2: false,
        emailNumber:'',
        emailverificationCode:'',
        timer2: null,
        count2: 60,
        canGet2: true,
        getCodeBtn2:"Send",
        offCountdown2:0,
        emailTip: ''
    }),
    mounted(){
        this.getContractData();
    },
    methods:{
        async getContractData(){
            let resData = await getContractInfo(false).then(res=> res.data);
            if(resData.ErrorCode==0){
                if(store.get(`constractInfo_${this.user.tuid}`)){
                    console.log('get from storage')
                    this.form = store.get(`constractInfo_${this.user.tuid}`);
                }
                if(resData.Body != '' && resData.Body!=null){
                    if(resData.Body.AuditStatus==1) this.isFirst = false;
      
                    this.form = resData.Body;

                    this.isPreview = resData.Body.AuditStatus;
                    this.downloadFile = resData.Body.ContractFile;
                    this.contractTESOLFile = resData.Body.ContractTESOLFile;
                    this.remarkText = resData.Body.Remark;
                    switch (this.isPreview) {
                    case 0:
                        this.contractState = 'Auditing';
                        this.stateColor = '#F69898'
                        break;
                    case null:
                        this.contractState = 'Not Signed';
                        this.stateColor = '#32397a66'
                        break;
                    case 1:
                        this.contractState = 'Audit Passed! Click to download the contract';
                        this.stateColor = '#3E67FB';
                        this.submitText = "Audit Passed";
                        break;
                    case 2:
                        this.contractState = 'Audit failed ! Click for more';
                        this.stateColor = '#EE344C'
                        break;
                    default:
                        this.contractState = 'Not Signed';
                        this.stateColor = '#32397a66'
                        break;
                    }
                }
            }
        },
        replaceBank () {
            document.getElementById('bankPhotoFile').click();
        },
        replaceSigned () {
            document.getElementById('signedPhotoFile').click();
        },
        fileData(file){
            return new Promise((resolve,reject)=>{
                var reader = new FileReader();
                reader.readAsDataURL(file);                    
                reader.onload = (e)=> {
                    resolve(e.target.result)
                };
            })
        },
        changeBankPhoto (event) {  
            if(!event.target.files || event.target.files.length==0) return;
            this.form.BankStatementPhotoFile=event.target.files[0]
            this.form.BankStatementPhotoName = event.target.files[0].name; 

        },
        changeSignedPhoto (event) {  
            if(!event.target.files || event.target.files.length==0) return;
            this.form.ElectronicallySignedPhotoFile=event.target.files[0];
            this.form.ElectronicallySignedPhotoName = event.target.files[0].name; 
        },
        async previewContract(type){
            var key=`constractInfo_${this.user.tuid}`
            var signedPhotoFile='',statementPhotoFile=''
            if(this.form.ElectronicallySignedPhotoFile){
                signedPhotoFile=await this.fileData(this.form.ElectronicallySignedPhotoFile)
            }
            if(this.form.BankStatementPhotoFile){
                statementPhotoFile=await this.fileData(this.form.BankStatementPhotoFile)
            }
            store.set(key,{
                BankName: this.form.BankName,
                Branch: this.form.Branch,
                AccountNumber: this.form.AccountNumber,
                AccountName: this.form.AccountName,
                ElectronicallySignedPhotoFile: signedPhotoFile,
                BankStatementPhotoFile: statementPhotoFile,
                BankStatementPhotoName: this.form.BankStatementPhotoName,
                ElectronicallySignedPhotoName: this.form.ElectronicallySignedPhotoName

            });
            store.set("TUID",this.user.tuid);
            type==1?
            window.open("/signContractCustom/contractCustom")
            :
            window.open("/signContract/tesolCertification")
        },
        processInfo(){
            if(this.isPreview==2) this.isRemark = true;
            if(this.isPreview==1) this.download = !this.download
        },
        downloadContract(type){
            type==1?
            window.open(this.downloadFile)
            :
            window.open(this.contractTESOLFile)
        },
        closeRemark(){
            this.isRemark = false;
        },
        dataURLToFile:(dataurl,filename)=>{
            var arr = dataurl.split(','),
	        mime = arr[0].match(/:(.*?);/)[1],
	        bstr = atob(arr[1]),
	        n = bstr.length,
	        u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        async submit(){
            
            var requestParam={
                BankName:this.form.BankName,
                AccountNumber:this.form.AccountNumber,
                Branch:this.form.Branch,
                AccountName:this.form.AccountName,
                AuthCode:this.authCode,
                IsCustomized: true
            }

            try{
                var fileArray=[]

                try{
                    if(this.form.BankStatementPhotoFile && !(this.form.BankStatementPhotoFile instanceof File)){
                        this.form.BankStatementPhotoFile=this.dataURLToFile(this.form.BankStatementPhotoFile,this.form.BankStatementPhotoName)
                    }
                    if(this.form.ElectronicallySignedPhotoFile && !(this.form.ElectronicallySignedPhotoFile instanceof File)){
                        this.form.ElectronicallySignedPhotoFile=this.dataURLToFile(this.form.ElectronicallySignedPhotoFile,this.form.ElectronicallySignedPhotoFile)
                    }
                }catch(e){
                    this.form.BankStatementPhotoFile=null
                    this.form.ElectronicallySignedPhotoFile=null
                }

                if(this.form.BankStatementPhotoFile){
                    fileArray.push({
                        key:'BankStatement',
                        module:'BankStatement',
                        file: this.form.BankStatementPhotoFile
                    })
                }
                if(this.form.ElectronicallySignedPhotoFile){
                    fileArray.push({
                        key:'ElectronicallySigned',
                        module:'ElectronicallySigned',
                        file: this.form.ElectronicallySignedPhotoFile
                    })
                }
            
                var file_bank,file_sign;
                if(fileArray.length>0){
                    var _uploader=new uploader({
                        module:'BankStatement',
                        progressbar: this.$root.$progressbar,
                        alert: this.$root.$alert
                    })
                    var uploadResult = await _uploader.uploadBatchWithKey(fileArray)
                    if(uploadResult.ErrorCode!=0){
                        this.$root.$alert(uploadResult.Msg||'Upload fail.')
                        return
                    }
                    var fileData=uploadResult.Body

                    if(fileData && fileData["BankStatement"]){
                        requestParam.BankStatement=fileData["BankStatement"][0]
                    }
                    if(fileData && fileData["ElectronicallySigned"]){
                        requestParam.ElectronicallySigned=fileData["ElectronicallySigned"][0]
                    }
                }
                let resData =  await saveContractInfo(requestParam).then(res=>{
                    return res.data
                })
                if(resData.ErrorCode==0) {
                    store.remove(`constractInfo_${this.user.tuid}`);
                    this.$root.$alertTips(resData.Msg, 'success').then(()=>{
                        this.getContractData();
                    })
                }else {
                    this.$root.$alertTips(resData.Msg, 'error')
                }
            }catch(err){
                this.$root.$alertTips(err)
            }
        },
        onSubmit(){
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                console.log('form-error');
                return
            }
            if(this.currentVerifyType == 1){
                this.SignPhoneInfo()
            }else{
                this.dialog2 = true
            }
        },

        // 验证码弹框
        async sendCode(){
            this.verificationCode = ''
            this.$refs.codeForm.resetValidation()
            if (!this.$refs.phoneForm.validate()) {
                return
            }
             let resInfo = await sendVerificationCode(this.phoneNumber,"+"+this.areaCode).then(res=>{
                return res.data;
            })
            if (!this.timer && resInfo.ErrorCode===0) {
                const TIME_COUNT = 60;
                this.count = TIME_COUNT;
                this.canGet = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        this.getCodeBtn = '('+this.count+")s";
                    } else {
                        this.canGet = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.getCodeBtn = 'Send'
                    }
                    this.offCountdown = this.count
                }, 1000)
            }
           
           let type = resInfo.ErrorCode===0?'success':'error';
           this.$root.$alertTips(resInfo.Msg,type);
        },
        async bindPhone(){
            if (!this.$refs.codeForm.validate() || !this.$refs.phoneForm.validate()) {
                return
            }
            signContractVerifyCode(this.phoneNumber, this.verificationCode,"+"+this.areaCode).then(res=>{
                try{
                    if(res.data.ErrorCode==0) {
                        this.dialog = false;

                        this.authCode = res.data.Body;
                        this.submit();
                    }else {
                        this.$root.$alertTips(res.data.Msg,"error");
                    }
                }catch(error){
                    this.$root.$alertTips(error);
                }
            })
        },
        SignPhoneInfo(){
            getSignPhoneInfo().then(res=>{
                let data = res.data.Body;
                if(data.ShowStatus==1){ 
                    this.dialog = true;
                    this.phoneNumber = data.Phone;
                    this.verificationCode = "";
                    this.getCodeBtn = "Send";
                    this.count = 60;
                    this.canGet = true;
                    this.areaCode = data.CountryCode.slice(1);
                }
            })
        },
        changeVerifyType(type){
            this.currentVerifyType = type
            if(type === 1){
                this.dialog = true
                this.dialog2 = false
            }
            if(type ===2){
                this.dialog = false
                this.dialog2 = true
            }  
        },
        async sendEmailCode(){
            this.canGet2 = false;
            this.emailverificationCode = ''
            this.emailTip = ''
            this.$refs.codeForm2.resetValidation()
       
             let resInfo = await sendEmailVerificationCode().then(res=>{
                return res.data;
            })
            if (!this.timer2 && resInfo.ErrorCode===0 && resInfo.Body && resInfo.Body.Item1 == 1) {
                const TIME_COUNT = 60;
                this.count2 = TIME_COUNT;
                this.canGet2 = false;
                this.timer2 = setInterval(() => {
                    if (this.count2 > 0 && this.count2 <= TIME_COUNT) {
                        this.count2--;
                        this.getCodeBtn2 = '('+this.count2+")s";
                    } else {
                        this.canGet2 = true;
                        clearInterval(this.timer2);
                        this.timer2 = null;
                        this.getCodeBtn2 = 'Send'
                    }
                    this.offCountdown2 = this.count2
                }, 1000)

                this.emailTip = `The verification code has been sent to your email ${resInfo.Body.Item3}`
                this.$root.$alertTips(this.emailTip,'success');
            }else{
                this.canGet2 = true
                this.$root.$alertTips(resInfo.Body.Item2, 'error');
            }
           
        },
        async bindEmail(){
            if (!this.$refs.codeForm2.validate()) {
                return
            }
            signContractEmailVerifyCode(this.emailverificationCode).then(res=>{
                try{
                    if(res.data.ErrorCode==0) {
                        this.dialog2 = false;

                        this.authCode = res.data.Msg;
                        this.submit();
                    }else {
                        this.$root.$alertTips(res.data.Msg,"error");
                    }
                }catch(error){
                    this.$root.$alertTips(error);
                }
            })
        },

    },
    beforeRouteEnter (to, from, next) {
        showContract().then(res=>{
            if(!res.data.Body.Item1 || res.data.Body.Item3==0){
                next({ path: '/404' })
            }
            else{
              next()
            }
        })
    },
    watch:{
        dialog:function(v){
            if(v && this.timer){
                this.canGet = false;
                this.count = this.offCountdown
                this.getCodeBtn = '('+this.count+")s";
            }
        },
        dialog2:function(v){
            if(v && this.timer2){
                this.canGet2 = false;
                this.count2 = this.offCountdown2
                this.getCodeBtn2 = '('+this.count2+")s";
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  @import "./signContract";
</style>